"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressClient = void 0;
const AddressExceptions_1 = require("./entities/AddressExceptions");
const base_client_1 = require("@deliverr/base-client");
const client_auth_1 = require("@deliverr/client-auth");
const lodash_1 = require("lodash");
const core_auth_1 = require("@deliverr/core-auth");
const commons_logs_1 = require("@deliverr/commons-logs");
const ADDRESS_SERVICE_BASE_URL = process.env.ADDRESS_SERVICE_BASE_URL;
class AddressClient extends base_client_1.ApiClient {
    constructor(config) {
        const baseURL = `${config.baseURL || ADDRESS_SERVICE_BASE_URL}`;
        if (!baseURL) {
            const errorMessage = "ADDRESS_SERVICE_BASE_URL is not set/provided";
            commons_logs_1.log.warn(errorMessage);
            throw new Error(errorMessage);
        }
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            super({
                ...config,
                baseURL,
                authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL,
                tokenRefreshFn: tokenHandler.getTokenFn(),
            });
        }
        else {
            super({
                authEngine: core_auth_1.AuthEngine.COGNITO,
                baseURL,
            });
        }
    }
    async createAllowlistEntry(sellerId, street1, street2, city, zip, state, country) {
        try {
            return await this.post(`/allowlist-address/add`, {
                sellerId,
                street1,
                street2,
                city,
                zip,
                state,
                country,
            });
        }
        catch (error) {
            return this.handleError(error, { error, sellerId });
        }
    }
    async getAllowlistEntry(sellerId, street1, street2, city, zip, state, country) {
        try {
            return await this.post(`/allowlist-address/search`, {
                sellerId,
                street1,
                street2,
                city,
                zip,
                state,
                country,
            });
        }
        catch (error) {
            return this.handleError(error, { error, sellerId });
        }
    }
    async getAllowListBySellerId(sellerId, page) {
        try {
            return await this.get(`/allowlist-address/view/${sellerId}?page=${page}`);
        }
        catch (error) {
            return this.handleError(error, { error, sellerId });
        }
    }
    async updateAllowlistEntry(id, sellerId, street1, street2, city, zip, state, country) {
        try {
            return await this.put("/allowlist-address/update", {
                id,
                sellerId,
                street1,
                street2,
                city,
                zip,
                state,
                country,
            });
        }
        catch (error) {
            return this.handleError(error, { error, sellerId, id });
        }
    }
    async deleteAllowlistEntry(id) {
        try {
            return await this.delete(`/allowlist-address/delete/${id}`);
        }
        catch (error) {
            return this.handleError(error, { error, id });
        }
    }
    async searchAllowlistEntries(sellerId, searchString, page) {
        try {
            return await this.post(`/allowlist-address/search/entries`, {
                sellerId,
                searchString,
                page,
            });
        }
        catch (error) {
            return this.handleError(error, { error, sellerId, searchString });
        }
    }
    async validateAddress(address, skipThirdPartyValidation = false, skipFieldValidations = false) {
        try {
            return await this.post("/validate", address, {
                skipThirdPartyValidation,
                skipFieldValidations,
            });
        }
        catch (error) {
            return this.handleError(error, { error, address });
        }
    }
    /**
     * Helper function to handle errors and map them to the OptionalApiResponse type
     * This is an adapted version based on the `handleApiError` in lib-commons
     * @param error
     * @param logCtx log context containing any data that should be logged. The error will always be included in the log.
     * @private
     */
    handleError(error, logCtx = {}) {
        logCtx = {
            ...logCtx,
            error,
        };
        // Handle unknown/unexpected error type thrown
        if (!(0, lodash_1.get)(error, "isAxiosError", false)) {
            commons_logs_1.log.error(logCtx, "An unexpected error type was thrown");
            return {
                error: {
                    code: AddressExceptions_1.AddressExceptions.UNKNOWN_ERROR,
                    message: "An unknown error occurred",
                },
            };
        }
        const axiosError = error;
        // Handle client errors (i.e. ECONNREFUSED, ECONNRESET or ECONABORTED)
        if (!axiosError.response?.status) {
            commons_logs_1.log.error(logCtx, "Client error trying to connect to server");
            return {
                error: {
                    code: AddressExceptions_1.AddressExceptions.UNKNOWN_ERROR,
                    message: "Client error trying to connect to server",
                },
            };
        }
        // Handle basic verification of error payload shape
        const responseData = (0, lodash_1.get)(axiosError, "response.data");
        if ((0, lodash_1.has)(responseData, "error.code") && (0, lodash_1.has)(responseData, "error.message")) {
            return responseData;
        }
        // Handle Zod schema validation errors
        if ((0, lodash_1.has)(responseData, "error.issues")) {
            const errorResponse = responseData;
            if (errorResponse.error.name === "ZodError") {
                const errorMessage = errorResponse.error.issues
                    .map((issue) => `${issue.path.slice(-1)}: ${issue.message}`)
                    .join(", ");
                return {
                    error: {
                        code: AddressExceptions_1.AddressExceptions.INVALID_INPUT,
                        message: errorMessage,
                    },
                };
            }
        }
        // Handle unexpected error payload shape
        commons_logs_1.log.error(logCtx, "An unknown error was returned");
        return {
            error: {
                code: AddressExceptions_1.AddressExceptions.UNKNOWN_ERROR,
                message: "Unknown error was returned",
            },
        };
    }
}
exports.AddressClient = AddressClient;
//# sourceMappingURL=AddressClient.js.map